var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-gis-wms-map"},[_c('div',{staticClass:"content-gis-map"},[_c('div',{style:(_vm.minHeight),attrs:{"id":`${_vm.nameMap}_${_vm.initialDate}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }